<template>
  <div ref="srcoll">
    <el-dialog
      title="经营类目"
      :visible.sync="dialogVisible2"
      width="977px"
      show-divider
      show-shadow
      class="dialog-center"
      :before-close="handleClose"
      custom-class="el-dialog--customize"
    >
      <div v-loading="flag">
        <div
          class="content"
          v-infinite-scroll="load"
          infinite-scroll-distance="30"
          :infinite-scroll-disabled="num == 9"
        >
          <div class="content_item" v-for="(item, idx) in mockData" :key="idx">
            <div class="category-one" :title="item.categoryName">
              {{ item.categoryName }}
            </div>
            <div class="category-wrapper">
              <div class="category-two" v-if="!item.children.length">
                <div class="category-two-left">
                  <el-checkbox style="opacity: 0">是的发生的</el-checkbox>
                </div>
              </div>
              <div
                class="category-two"
                v-for="(item2, idx2) in item.children"
                :key="idx2"
              >
                <div class="category-two-left">
                  <el-checkbox
                    :label="item2.categoryName"
                    :title="item2.categoryName"
                    v-model="item2.checked"
                    @change="handleCheckedAll(item2, idx)"
                  ></el-checkbox>
                </div>
                <div class="category-two-right">
                  <el-row>
                    <el-col
                      :span="6"
                      v-for="(item3, idx3) in item2.children"
                      :key="idx3"
                    >
                      <el-checkbox-group
                        v-model="item2.checkList"
                        :checkList="item2.checkList"
                        @change="handleCheckedChange(item2, idx, item3)"
                      >
                        <el-checkbox
                          :title="item3.categoryName"
                          :class="{ textHiddenCk: item2.children.length > 1 }"
                          :label="item3.categoryName"
                        ></el-checkbox>
                      </el-checkbox-group>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </div>
          <div style="margin: 10px 0px 0px 472px" v-if="num > 8">
            已经到底了
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogVisible2 = false"
          >取消</el-button
        >
        <el-button size="mini" type="primary-font-mini" @click="determine"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getQryCate } from "@/api/category-template.js";

export default {
  name: "category",
  props: {
    dialogVisible: Boolean,
    defaultData: Array,
  },
  data() {
    return {
      num: 1,
      mockData: [],
      localData: [],
      dialogVisible2: false,
      flag: false,
    };
  },
  watch: {
    dialogVisible(val) {
      this.dialogVisible2 = val;
    },
    dialogVisible2(val) {
      this.$emit("dialogVisible2", val);
    },
  },
  mounted() {
    this.dialogVisible2 = this.dialogVisible;
  },
  methods: {
    load() {
      this.pushData();
    },
    // jia(){
    //   this.pushData();
    // },
    // scroll(){
    //   window.addEventListener("scroll",);
    //   console.log(document.getElementById("divID").scrollTop);
    // },
    handleClose(done) {
      console.log("测试");
      done();
    },
    handleCheckedAll(data, childrenOneIdx) {
      let join = "";
      let joinId = "";
      if (data.checked && data.children.length) {
        data.children.forEach((item) => {
          data.checkList.push(item.categoryName);
        });
        this.localData.forEach((item2, idx) => {
          if (data.id === item2.isTrueId) {
            this.localData.splice(idx, 1);
          }
        });
        let sessionId = [];
        data.checkList.forEach((label) => {
          data.children.forEach((reqId) => {
            if (reqId.categoryName === label) {
              sessionId.push(reqId.categoryCode);
            }
          });
        });
        join =
          this.mockData[childrenOneIdx].categoryName +
          ">" +
          data.categoryName +
          ">" +
          data.checkList.join("\\");
        joinId =
          this.mockData[childrenOneIdx].categoryCode +
          "," +
          data.categoryCode +
          "," +
          sessionId.join("\\");
        this.localData.push({
          joinLabel: join,
          joinId: joinId,
          isTrueId: data.id,
        });
      }
      if (!data.checked && data.children.length) {
        this.localData.forEach((item2, idx) => {
          if (data.id === item2.isTrueId) {
            this.localData.splice(idx, 1);
          }
        });
        data.checkList = [];
      }
      if (!data.children.length) {
        let twoCategoryLabel = "";
        let twoCategoryId = "";
        let oneItemSession = this.mockData[childrenOneIdx].children.filter(
          (oneItem) => oneItem.checked && !oneItem.checkList.length
        );
        this.localData.forEach((delItem, delIdx) => {
          if (this.mockData[childrenOneIdx].id === delItem.oneId) {
            this.localData.splice(delIdx, 1);
          }
        });
        if (oneItemSession.length) {
          oneItemSession.forEach((filterItem) => {
            twoCategoryLabel += filterItem.categoryName + "\\";
            twoCategoryId += filterItem.categoryCode + "\\";
          });
          twoCategoryLabel = twoCategoryLabel.substr(
            0,
            twoCategoryLabel.length - 1
          );
          twoCategoryId = twoCategoryId.substr(0, twoCategoryId.length - 1);
          join =
            this.mockData[childrenOneIdx].categoryName + ">" + twoCategoryLabel;
          joinId =
            this.mockData[childrenOneIdx].categoryCode + "," + twoCategoryId;
          this.localData.push({
            joinLabel: join,
            joinId: joinId,
            isTrueId: data.id,
            oneId: this.mockData[childrenOneIdx].id,
            threeFalse: true,
          });
        }
      }
      this.$forceUpdate();
      console.log(data, this.localData, "全选状态");
    },
    handleCheckedChange(item, idx) {
      let join = "";
      let joinId = "";
      // 1.每次选择清空当前级数据，方便拼接/  2.取消选择的时候也会清楚
      this.localData.forEach((isItem, isIdx) => {
        if (isItem.isTrueId === item.id) {
          this.localData.splice(isIdx, 1);
        }
      });
      // 当选择的时候进入该条件
      if (item.checkList.length) {
        this.localData.forEach((delThreeFalse, delThreeFalseIdx) => {
          if (delThreeFalse.threeFalse && item.id === delThreeFalse.isTrueId) {
            this.localData.splice(delThreeFalseIdx, 1);
          }
        });
        item.checked = true;
        let sessionId = [];
        item.checkList.forEach((label) => {
          item.children.forEach((reqId) => {
            if (reqId.categoryName === label) {
              sessionId.push(reqId.categoryCode);
            }
          });
        });
        join =
          this.mockData[idx].categoryName +
          ">" +
          item.categoryName +
          ">" +
          item.checkList.join("\\");
        joinId =
          this.mockData[idx].categoryCode +
          "," +
          item.categoryCode +
          "," +
          sessionId.join("\\");
        this.localData.push({
          joinLabel: join,
          joinId: joinId,
          isTrueId: item.id,
        });
      } else {
        item.checked = false;
        this.localData.forEach((delItem, delIdx) => {
          if (delItem.isTrueId === item.id) {
            this.localData.splice(delIdx, 1);
          }
        });
      }
      this.$forceUpdate();
      console.log(this.localData, "数据");
    },
    determine() {
      this.dialogVisible2 = false;

      for (var i = 0; i < this.localData.length; i++) {
        for (var j = i + 1; j < this.localData.length; j++) {
          if (this.localData[i].isTrueId == this.localData[j].isTrueId) {
            //第一个等同于第二个，splice方法删除第二个
            this.localData.splice(j, 1);
            j--;
          }
        }
      }

      this.$emit("determine", this.localData);
      console.log("我是穿过去的参数", this.localData);
    },
    pushData() {
      // let loadingObj
      // this.localData=[]
      console.log(this.defaultData, "默认数据");
      let splitData = [];
      let isDefault = false;
      if (this.defaultData && this.defaultData.length) {
        isDefault = true;
        this.defaultData.forEach((item) => {
          let splitCode = item.categoryCodes.split(",");
          // let splitName = item.categoryNames.split('>')
          let oneCode = splitCode[1];
          let bottomCodes = splitCode[2].split("\\");
          // let bottomCodes = splitName[splitName.length - 1].split('/')
          splitData.push({ oneCode, bottomCodes });
        });
      }
      console.log(splitData, "过滤默认数据");

      this.flag = true;
      getQryCate({ num: this.num++ })
        .then((res) => {
          if (res.data.code === "0") {
            res.data.data.forEach((item) => {
              item.children.forEach((itemChildren) => {
                if (isDefault) {
                  itemChildren.checkList = [];
                  itemChildren.checked = false;
                  splitData.forEach((itemSplit, idxSplit) => {
                    if (itemSplit.oneCode === itemChildren.categoryCode) {
                      this.defaultData[idxSplit].isTrueId = itemChildren.id;
                      itemSplit.bottomCodes.forEach((i, d) => {
                        itemChildren.children.forEach((item2, index2) => {
                          if (i == item2.categoryCode) {
                            itemChildren.checkList.push(item2.categoryName);
                          }
                        });
                      });
                      itemChildren.checked = true;
                    }
                  });
                } else {
                  itemChildren.checkList = [];
                  itemChildren.checked = false;
                }
              });
            });
            if (isDefault) {
              this.defaultData.forEach((item) => {
                let pushBo = {
                  isTrueId: item.isTrueId,
                  joinId: item.categoryCodes,
                  joinLabel: item.categoryNames,
                };
                this.localData.push(pushBo);
              });
            }
            let mockarr = res.data.data;
            mockarr.forEach((item) => {
              this.mockData.push(item);
            });
            // for(let index = 0;index <mockarr.length;mockarr++){
            //   this.mockData.push(mockarr[index])
            // }

            console.log("this.mockData", this.mockData);
            this.flag = false;
          }
        })
        .catch((e) => {
          this.flag = false;
          // loadingObj.close()
          // loadingObj = null
          console.log(e);
        });
      console.log(this.mockData, "初始化数据");
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  height: 480px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 1px;

  padding-bottom: 1px;
  /*border-bottom: 1px solid #f1f1f1;*/
  .content_item {
    display: flex;
    border-top: 1px solid #f1f1f1;
    border-left: 1px solid #f1f1f1;
    border-right: 1px solid #f1f1f1;
    margin-bottom: -1px;
    .category-one {
      width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 12px 0 12px 20px;
      border-right: 1px solid #f1f1f1;
    }
    .category-wrapper {
      width: calc(100% - 150px);
      .category-two {
        display: flex;
        border-bottom: 1px solid #f1f1f1;
        margin-bottom: -1px;
        .category-two-left,
        .category-two-right {
          padding: 12px 0 0 20px;
        }
        .category-two-left {
          width: 130px;
          border-right: 1px solid #f1f1f1;
          padding-bottom: 10px;
          /deep/ .el-checkbox {
            display: flex;
            align-items: center;
            user-select: initial;
          }
          /deep/ .el-checkbox__label {
            width: 105px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .category-two-right {
          width: calc(100% - 130px);
          /deep/ .el-checkbox {
            /*margin-right: 73px;*/
            margin-right: 8px;
            margin-bottom: 10px;
          }
          .textHiddenCk {
            /deep/ .el-checkbox__label {
              width: 120px;
              height: 20px;
              vertical-align: middle;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
      .category-two:last-of-type {
        border: none !important;
      }
    }
  }
  .content_item:last-of-type {
    border-bottom: 1px solid #f1f1f1;
  }
}
/deep/ .el-dialog__body {
  max-height: 120vh !important;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
}
</style>
